export default "__VITE_ASSET__x0IjwpWf__"